import { render, staticRenderFns } from "./EndControlPC.vue?vue&type=template&id=a4872b34&scoped=true"
import script from "./EndControlPC.vue?vue&type=script&setup=true&lang=ts"
export * from "./EndControlPC.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EndControlPC.vue?vue&type=style&index=0&id=a4872b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4872b34",
  null
  
)

export default component.exports